import classNames from 'classnames/bind';
import { memo } from 'react';
import styles from './AgentNotePopup.module.scss';
import { CloseOutlined } from '@ant-design/icons';
import Title from 'antd/lib/typography/Title';
import { useTranslation } from 'react-i18next';
import TextEditor from '../textEditor/TextEditor';
import './AgentNotePopup.scss';
import { ModeTextEditorEnum, ThemeTextEditorEnum } from '~/utils/enum';

type Props = {
  description: string;
  isOpen: boolean;
  onClose: () => void;
};

const cx = classNames.bind(styles);

const AgentNotePopup = (props: Props) => {
  //#region Destructuring Props
  const { description, isOpen, onClose } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <div className={cx('agentNotePopupContainer', isOpen ? 'show' : 'hide')}>
      <CloseOutlined className={cx('agentNotePopupCloseIcon')} onClick={onClose} />
      <Title className={cx('agentNotePopupTitle')} level={5}>
        {t('agent_sub_title_note')}
      </Title>

      <div className={'agentNotePopupTextEditorContainer'}>
        <TextEditor className={cx('agentNotePopupTextEditor')} theme={ThemeTextEditorEnum.BUBBLE} mode={ModeTextEditorEnum.VIEW} value={description} />
      </div>
    </div>
  );
};

export default memo(AgentNotePopup);
